import { useQuery } from '@apollo/client';

import { GET_OUTPUT_MAPPER_CONFIG } from './queries.ts';

/**
 * Whether no Output Mapper config has been stored for the owner yet (the backend then serves a
 * built-in default, flagged via `isDefault`). Lets manager-facing forms warn about a missing
 * mapping even though the editor itself is only visible to support users.
 */
const useOutputMapperConfigMissing = ({
    outputMapperKey,
    ownerId,
    skip = false,
}: {
    outputMapperKey: string;
    ownerId?: string;
    skip?: boolean;
}): boolean => {
    const { data } = useQuery(GET_OUTPUT_MAPPER_CONFIG, {
        variables: { key: outputMapperKey, ownerId },
        skip: skip || !ownerId,
    });

    return data?.outputMapperConfig?.isDefault === true;
};

export default useOutputMapperConfigMissing;
